import { AccessTime, PlayArrow } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Chip,
  Divider,
  Typography,
} from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

const BookCard = ({ bookData }) => {
  return (
    <Link
      to={`${bookData.id}`}
      style={{ textDecoration: "none", color: "inherit" }}
    >
      <Card
        sx={{
          width: {
            xs: "95%",
            sm: 300,
            md: 355,
          },
          marginY: 2,
          borderRadius: "16px",
          padding: 1.2,
          background:
            "linear-gradient(#fff8eb,#fff8eb) padding-box, linear-gradient(135deg,#ffb75e,#ed8f03) border-box",
          border: "2px solid transparent",
          transition: "transform 0.25s ease, box-shadow 0.25s ease",
          boxShadow: "0 10px 28px rgba(0,0,0,0.10)",
          "&:hover": {
            transform: "translateY(-6px)",
            boxShadow: "0 16px 36px rgba(0,0,0,0.14)",
          },
        }}
        elevation={0}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          <div
            style={{
              position: "relative",
              width: "100%",
              borderRadius: 14,
              overflow: "hidden",
              aspectRatio: "16 / 9",
            }}
          >
            <CardMedia
              component="img"
              image={bookData.snippet.thumbnails.high.url}
              alt={bookData.snippet.title}
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                transform: "scale(1)",
                transition: "transform .35s ease",
                "&:hover": { transform: "scale(1.04)" },
              }}
            />
            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(to top, rgba(0,0,0,0.45) 0%, rgba(0,0,0,0.1) 60%, rgba(0,0,0,0) 100%)",
              }}
            />
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 68,
                height: 68,
                borderRadius: "50%",
                background: "rgba(255,255,255,0.9)",
                boxShadow: "0 8px 20px rgba(0,0,0,0.25)",
              }}
            >
              <PlayArrow style={{ color: "#ed8f03", fontSize: 40 }} />
            </div>
          </div>
          {/* <Chip
            label="10 Videos"
            sx={{
              zIndex: "101",
              position: "absolute",
              bottom: "8px",
              right: "8px",
              borderRadius: "5px",
              backgroundColor: "#ffffffcf",
            }}
          /> */}
        </div>
        <CardContent>
          <Typography
            gutterBottom
            variant="h6"
            fontWeight="bold"
            component="div"
            sx={{
              fontSize: { xs: 20, sm: 21, md: 22 },
            }}
          >
            {bookData.snippet.title === "Private video"
              ? "Upcoming Book"
              : bookData.snippet.title.length > 50
              ? `${bookData.snippet.title.slice(0, 50)}...`
              : bookData.snippet.title}
          </Typography>
          <Typography gutterBottom variant="p" fontWeight="bold">
            <Chip
              label={bookData.snippet.channelTitle}
              variant="outlined"
              sx={{
                fontWeight: 600,
                bgcolor: "#ffffff",
                borderColor: "#e0e0e0",
                borderRadius: 9999,
              }}
            />
          </Typography>
        </CardContent>
        <Divider />
        <CardActions>
          <Button
            fullWidth
            variant="contained"
            color="warning"
            disabled={
              bookData.snippet.thumbnails.high.url ===
              "https://i.ytimg.com/img/no_thumbnail.jpg"
            }
            startIcon={
              bookData.snippet.thumbnails.high.url ===
              "https://i.ytimg.com/img/no_thumbnail.jpg" ? (
                <AccessTime />
              ) : (
                <PlayArrow />
              )
            }
            sx={{
              py: 1.25,
              fontWeight: 800,
              letterSpacing: 0.6,
              borderRadius: 9999,
              textTransform: "none",
              background:
                bookData.snippet.thumbnails.high.url ===
                "https://i.ytimg.com/img/no_thumbnail.jpg"
                  ? undefined
                  : "linear-gradient(90deg, #ffb75e 0%, #ed8f03 100%)",
              boxShadow:
                bookData.snippet.thumbnails.high.url ===
                "https://i.ytimg.com/img/no_thumbnail.jpg"
                  ? undefined
                  : "0 6px 18px rgba(237,143,3,0.3), 0 2px 6px rgba(0,0,0,0.1)",
              "&:hover": {
                background:
                  "linear-gradient(90deg, #ffad4b 0%, #e57f00 100%) !important",
                transform: "translateY(-2px)",
              },
            }}
            aria-label={
              bookData.snippet.thumbnails.high.url ===
              "https://i.ytimg.com/img/no_thumbnail.jpg"
                ? "Coming soon"
                : "Watch now"
            }
          >
            {bookData.snippet.thumbnails.high.url ===
            "https://i.ytimg.com/img/no_thumbnail.jpg"
              ? "Coming soon"
              : "Watch Now"}
          </Button>
        </CardActions>
      </Card>
    </Link>
  );
};

export default BookCard;
